export default __webpack_public_path__ + "static/media/img4.cdbcf39a.png";